import React from "react";
import { CONFIG, formatPrice } from "../config";
import {
  useLivePrice,
  directionColor,
  PRICE_UP,
  PRICE_DOWN,
} from "../hooks/useLivePrice";

// Subtle monospaced market-data strip fixed above the header.
export default function TopStrip() {
  const { price, base, direction } = useLivePrice();
  const changePct = ((price - base) / base) * 100;
  const up = changePct >= 0;
  const priceColor = directionColor(direction, PRICE_UP);
  const pctColor = up ? PRICE_UP : PRICE_DOWN;

  return (
    <div className="w-full border-b hairline bg-[#080909]">
      <div className="mx-auto max-w-[1280px] px-5 sm:px-8 lg:px-[64px] h-9 flex items-center justify-between ticker-mono text-[11px] tracking-[0.16em] uppercase">
        {/* Left */}
        <div className="flex items-center gap-2.5 whitespace-nowrap overflow-hidden">
          <span className="flex items-center gap-2">
            <span className="pulse-dot inline-block w-[6px] h-[6px] rounded-full bg-[#7FB894]" />
            <span className="text-[#F1F2EF]">Live</span>
          </span>
          <span className="text-[#4c514e]">·</span>
          <span className="text-[#A0A5A2]">{CONFIG.element}</span>
          <span className="text-[#4c514e] hidden sm:inline">·</span>
          <span className="text-[#A0A5A2] hidden sm:inline">Platinum Spot</span>
          <span className="text-[#6D726F] hidden sm:inline">/ 10 mg</span>
        </div>

        {/* Right — live price */}
        <div className="flex items-center gap-2.5">
          <span
            className="tabular-nums tracking-[0.06em]"
            style={{ color: priceColor, transition: "color 0.4s ease" }}
          >
            {formatPrice(price)}
          </span>
          <span
            className="tabular-nums tracking-[0.04em]"
            style={{ color: pctColor, transition: "color 0.4s ease" }}
          >
            {up ? "+" : "−"}
            {Math.abs(changePct).toFixed(2)}%
          </span>
          <span className="text-[#6D726F] hidden sm:inline">{CONFIG.token}</span>
        </div>
      </div>
    </div>
  );
}
